import React, { useState, useCallback, memo } from "react";
import userimg from "../../../../assets/userimage.png";
import ImageModal from "../ImageModalComponent/ImageModalComponent";
import { useNavigate } from 'react-router-dom';

const ProfileCard = memo(({ person,onImageClick }) => (
  <div className="profile-carrd">
    <div>
      <img
        className="leaderboard-img-profile"
        src={person?.FilePath ? person?.FilePath: userimg}
        alt={person?.Name || ""}
        onClick={() => onImageClick(person?.FilePath || userimg)}
        style={{ cursor: person.FilePath ? "pointer" : "default" }}
      />
    </div>
    <h6 className="m-0">
      <b>{person?.Name || ""}</b>
    </h6>
  </div>
));

const TabContent = memo(
  ({
    activeTab,
    uniqueRanksThreeMonths,
    uniqueRanksSixMonths,
    uniqueRanksTwelveMonths,
      onImageClick,
  }) => (
    <div className="tab-content">
      <div
        id="threemonths"
        className={`tab-pane fade ${
          activeTab === "threemonths" ? "show active" : ""
        }`}
      >
        <div className="d-flex gap-2">
          {uniqueRanksThreeMonths?.map((person) => (
            <ProfileCard key={person.EmployeeID} person={person}  onImageClick={onImageClick}/>
          ))}
        </div>
      </div>
      <div
        id="sixmonths"
        className={`tab-pane fade ${
          activeTab === "sixmonths" ? "show active" : ""
        }`}
      >
        <div className="d-flex gap-2">
          {uniqueRanksSixMonths?.map((person) => (
            <ProfileCard key={person.EmployeeID} person={person}  onImageClick={onImageClick}/>
          ))}
        </div>
      </div>
      <div
        id="twelvemonths"
        className={`tab-pane fade ${
          activeTab === "twelvemonths" ? "show active" : ""
        }`}
      >
        <div className="d-flex gap-2">
          {uniqueRanksTwelveMonths?.map((person) => (
            <ProfileCard key={person.EmployeeID} person={person}  onImageClick={onImageClick}/>
          ))}
        </div>
      </div>
    </div>
  )
);

const LeaderboardSection = ({ uniqueRanksThreeMonths = [], uniqueRanksSixMonths = [], uniqueRanksTwelveMonths = [], leaderOpen,toggleLeaderOpen, }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("threemonths");
  const [modalImage, setModalImage] = useState(null);

  const handleTabChange = useCallback((tabId) => {
    setActiveTab(tabId);
  }, []);
  const handleImageClick = useCallback((imageUrl) => {
    setModalImage(imageUrl);
  }, []);

  const closeModal = useCallback(() => {
    setModalImage(null);
  }, []);
  return (
    <div className="row mt-2">
      <div className="col-md-12 dashKPI">
        <div className="custom-accordion">
          <div className="custom-header">
            <div className="d-flex justify-content-between">
              <div className="leader_Board-card">
                <h5 onClick={() => navigate('/achievers')} style={{ cursor: 'pointer' }}>Leaderboard</h5>
              </div>
            </div>
            <div className="d-flex gap-1">
            <div className="leader-tab">
              <ul className="nav leader-nav-tabs custom-nav-tabs">
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "threemonths" ? "active" : ""
                    }`}
                    onClick={() => handleTabChange("threemonths")}
                  >
                    3 Months
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "sixmonths" ? "active" : ""
                    }`}
                    onClick={() => handleTabChange("sixmonths")}
                  >
                    6 Months
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${
                      activeTab === "twelvemonths" ? "active" : ""
                    }`}
                    onClick={() => handleTabChange("twelvemonths")}
                  >
                    12 Months
                  </button>
                </li>
              </ul>
            </div>
            <span className={`arrow-icon ${leaderOpen ? "open" : ""}`} onClick={toggleLeaderOpen}>
              <i className="bi bi-arrow-down-circle-fill"></i>
            </span>
            </div>
          </div>
          <div
            className={`custom-body-leader ${leaderOpen ? "open" : "closed"}`}
          >
            <TabContent
              activeTab={activeTab}
              uniqueRanksThreeMonths={uniqueRanksThreeMonths}
              uniqueRanksSixMonths={uniqueRanksSixMonths}
              uniqueRanksTwelveMonths={uniqueRanksTwelveMonths}
                onImageClick={handleImageClick}
            />
          
          </div>
        </div>
      </div>
        {/* Use the reusable ImageModal */}
      <ImageModal
        isOpen={!!modalImage}
        imageUrl={modalImage}
        onClose={closeModal}
      />
    </div>
  );
};

export default memo(LeaderboardSection);
